import { render } from "./Service.vue?vue&type=template&id=532fbe19&scoped=true"
import script from "./Service.vue?vue&type=script&lang=ts"
export * from "./Service.vue?vue&type=script&lang=ts"

import "./Service.vue?vue&type=style&index=0&id=532fbe19&scoped=true&lang=css"
import "./Service.vue?vue&type=style&index=1&id=532fbe19&lang=css"
script.render = render
script.__scopeId = "data-v-532fbe19"

export default script